import { render, staticRenderFns } from "./newClientView.vue?vue&type=template&id=149c59a9&"
import script from "./newClientView.vue?vue&type=script&lang=js&"
export * from "./newClientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports